import React from "react";
import { stackList } from "../../data/ProjectData";
import "./About.css"; // Make sure to create this CSS file in the same directory

function About() {
  return (
    <div className="about-section">
      <div className="container">
        <h2 className="section-title">
          <span className="title-text">About Me</span>
        </h2>
        
        <div className="profile-card">
          <div className="profile-layout">
            {/* Profile Image Side */}
            <div className="profile-image-container">
              <div className="profile-image-wrapper">
                <img
                  src="/WhatsApp Image 2025-04-13 at 18.13.42_4484d92f.jpg"
                  alt="profile"
                  className="profile-image"
                />
              </div>
            </div>
            
            {/* Bio Content Side */}
            <div className="bio-container">
              <div className="bio-content">
                <p className="bio-paragraph fade-in" style={{animationDelay: "0.2s"}}>
                  Hello! My name is <span className="highlight">Dibyanjaya</span>. I am deeply passionate about creating engaging and user-centric digital experiences. With proficiency in HTML, CSS, and JavaScript, as well as hands-on experience with modern frontend frameworks like React.js, I bring a robust skill set to every project I undertake.
                </p>

                <p className="bio-paragraph fade-in" style={{animationDelay: "0.4s"}}>
                  Driven by a genuine curiosity for emerging technologies and a commitment to staying abreast of industry trends, I am constantly seeking opportunities to push the boundaries of innovation and elevate the standard of frontend development. Whether collaborating with cross-functional teams to bring concepts to life or delving into the intricacies of code optimization, I thrive in dynamic environments where creativity and technical excellence converge.
                </p>

                <p className="bio-paragraph fade-in" style={{animationDelay: "0.6s"}}>
                  Working collaboratively within a team towards a shared objective has been an incredibly rewarding and unique experience for me. I am eager to continue exploring exciting projects in the future, with a particular interest in web development and cross-platform mobile development.
                </p>
                
                <div className="tech-section fade-in" style={{animationDelay: "0.8s"}}>
                  <h3 className="tech-title">
                    Technologies I'm proficient with
                  </h3>
                  
                  <div className="tech-grid">
                    {stackList.map((stack, index) => (
                      <div 
                        key={index} 
                        className="tech-item"
                      >
                        <div className="tech-icon-container">
                          <img src={stack.img} alt={stack.name} className="tech-icon" />
                        </div>
                        <span className="tech-name">{stack.name}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;